export const userInfoKeys = {
  all: ['user-info'],
  details: () => [...userInfoKeys.all, 'detail'],
  detail: () => [...userInfoKeys.details()],
} as const;
